/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  INITIATE_CREATE_ORG_COMPLIANCE: {
    size: 10,
    skip: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.trag.profile',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_CREATE_ORG_COMPLIANCE' },
      },
    },
    INITIATE_CREATE_ORG_COMPLIANCE: {
      invoke: {
        id: 'createOrgCompliance',
        src: 'createOrgCompliance',
        onDone: {
          target: 'CREATE_ORG_COMPLIANCE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_ORG_COMPLIANCE_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    CREATE_ORG_COMPLIANCE_SUCCESS: {
      on: {
        MUTATE: { target: 'INITIATE_CREATE_ORG_COMPLIANCE' },
      },
    },
    CREATE_ORG_COMPLIANCE_ERROR: {
      on: {
        MUTATE: { target: 'INITIATE_CREATE_ORG_COMPLIANCE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
